import { Component, inject } from '@angular/core';
import { IconMenuButtonComponent } from 'src/app/shared/components/icon-menu-button/icon-menu-button.component';
import {
  GroupedLevelBenefit,
  LevelModel,
} from 'src/app/models/supplier-score.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { ToastService } from 'src/app/services/toast.service';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { NgClass } from '@angular/common';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { LevelBenefitsModalComponent } from '../level-benefits-modal/level-benefits-modal.component';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-level-benefits',
    templateUrl: './level-benefits.component.html',
    styleUrls: ['./level-benefits.component.scss'],
    imports: [IconMenuButtonComponent, MatMenu, MatMenuItem, NgClass, LevelBenefitsModalComponent, MatButtonModule, MatIconModule, PageHeaderComponent, EmptyStateComponent]
})
export class LevelBenefitsComponent {
  toastr = inject(ToastService);
  private readonly levelSvc = inject(SupplierService);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);


  public levels: LevelModel[] = [];
  public showBenefitModal: boolean = false;
  public selectedBenefitToEdit?: GroupedLevelBenefit;
  grouped: GroupedLevelBenefit[] = [];

  ngOnInit() {
    this.getlevels();
  }

  getlevels() {
    this.levelSvc.getAllLevels().subscribe({
      next: (data) => {
        this.levels = data;
        this.grouped = [];
        this.levels.forEach((level) => {
          level.levelBenefits.forEach((benefit) => {
            this.grouped.push({
              levelId: level.id,
              levelName: level.name,
              benefitId: benefit.id?.toString(),
              benefitDescription: benefit.description,
              benefitAdditional: benefit.additional,
            });
          });
        });
      },
    });
  }

  openModal(level?: GroupedLevelBenefit) {
    this.showBenefitModal = true;
    this.selectedBenefitToEdit = level;
  }

  backToBenefits() {
    this.showBenefitModal = false;
  }

  deleteLevelBenefit(id: any, levelName: string) {
    this.swalFire
      .SwalFireQuestion(
        'Eliminar el beneficio',
        `¿Está seguro que desea eliminar el beneficio asociado al nivel “${levelName}”?`,
        'Eliminar',
        'Cancelar'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.levelSvc.deleteBenefit(id).subscribe({
            next: (result) => {
              this.toastr.success(
                'Nivel beneficio',
                'El beneficio se ha eliminado correctamente.'
              );
              this.getlevels();
            },
            error: (err) => {
              this.toastr.error('Error', 'No se pudo eliminar el beneficio.');
            },
          });
        }
      });
  }
}
